export function getTenantId(): string {
  if (typeof window === 'undefined') {
    return 'default';
  }
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  
  // If it's a domain with a subdomain like workspace.nexchat.ai or workspace.localhost
  // hostname parts: ["workspace", "nexchat", "ai"] (length 3) or ["workspace", "localhost"] (length 2)
  if (parts.length > 2 || (parts.length === 2 && parts[1] === 'localhost')) {
    return parts[0];
  }
  
  // Fallback for easy local development testing via query parameter (e.g. localhost:4200?tenant=workspace_id)
  const urlParams = new URLSearchParams(window.location.search);
  const tenantParam = urlParams.get('tenant');
  if (tenantParam) {
    return tenantParam;
  }
  
  return 'default';
}
